import {Component, OnInit} from '@angular/core';
import {Category} from "./types/category.type";

declare const window: Window;
declare const $: any;

@Component({
  selector: 'tech-docs',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  i18n: Map<string, string>;
  categories: Category[];
  families: Category[];
  formats: Category[];
  isDisabled: boolean;
  selectedCategory: string | null;
  selectedFamily: string | null;

  ngOnInit(): void {
    const techDocsPage = window["techDocsPage"];

    this.i18n = techDocsPage.i18n;
    this.categories = techDocsPage.categories;
    this.isDisabled = true;
    this.families = [];
    this.formats = [];
    this.selectedCategory = null;
    this.selectedFamily = null;

    // Check the params and set the dropdown values if they match
    const params = new URLSearchParams(window.location.search);
    const category = params.get("category") || "";
    const family = params.get("family") || "";
    const format = params.get("format") || "";

    const self = this;

    setTimeout(function() {
      self.setCategoryIfExists(category, family, format);
    }, 10);
  }

  private setCategoryIfExists(category: string, family: string, format: string) {
    if (category) {
      $("#category").val(category);
      this.changeCategory(category);

      const self = this;

      setTimeout(function() {
        self.setFamilyIfExists(family, format);
      }, 10);
    }
  }

  private setFamilyIfExists(family: string, format: string) {
    if (family) {
      $("#family").val(family);
      this.changeFamily(family);
      this.setButtonStateIfHasCategoryAndFamily();

      const self = this;

      setTimeout(function() {
        self.setFormatIfExists(format);
      }, 10);
    }
  }

  private setFormatIfExists(format: string) {
    if (format) {
      $("#format").val(format);
      this.setButtonStateIfHasCategoryAndFamily();
    }
  }

  onCategoryChange(event: any) {
    this.changeCategory(event.target.value);
  }

  changeCategory(category: string) {
    this.selectedCategory = category;
    this.families = [];
    this.formats = [];

    if (category) {
      const categoryIndex = this.findCategoryIndexById(category, this.categories);

      this.families = this.categories[categoryIndex].subcategories;
    }

    this.setButtonStateIfHasCategoryAndFamily();
  }

  onFamilyChange(event: any) {
    this.changeFamily(event.target.value);
  }

  changeFamily(family: string) {
    this.selectedFamily = family;
    this.formats = [];

    if (family) {
      const familyIndex = this.findCategoryIndexById(family, this.families);

      this.formats = this.families[familyIndex].subcategories;
    }

    this.setButtonStateIfHasCategoryAndFamily();
  }

  setButtonStateIfHasCategoryAndFamily() {
    this.isDisabled = !(this.selectedCategory && this.selectedFamily);
  }

  findCategoryIndexById(id: string, categories: Category[]) {
    for (let category of categories) {
      if (parseInt(id) === category.id) {
        return categories.indexOf(category);
      }
    }
  }
}
